module.exports = __webpack_public_path__ + "blacktwocandles.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/blacktwocandles.png
// module id = 872
// module chunks = 0